import React, { useState } from 'react';
import './header.css';
import Contributions from '../contributions/contributions.js';
import arrowOutwardIcon from '../../images/icons/arrow_outward.svg';
import copyIcon from '../../images/icons/copy.svg';

const EMAIL_ADDRESS = 'gvns0x@gmail.com';
const LINKEDIN_URL = 'https://www.linkedin.com/in/gvns/';
const GITHUB_URL = 'https://github.com/gvns0x';
const X_URL = 'https://x.com/gvns0x';
const CV_URL = '/cv.pdf';

export default function Header() {
    const [emailLabel, setEmailLabel] = useState('Email');

    const handleCopyEmail = async () => {
        try {
            await navigator.clipboard.writeText(EMAIL_ADDRESS);
        } catch (err) {
            const textarea = document.createElement('textarea');
            textarea.value = EMAIL_ADDRESS;
            textarea.setAttribute('readonly', '');
            textarea.style.position = 'fixed';
            textarea.style.left = '-9999px';
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand('copy');
            document.body.removeChild(textarea);
        }

        setEmailLabel('Copied');
        setTimeout(() => {
            setEmailLabel('Email');
        }, 2000);
    };

    return (
        <div className="header">
            <div className="header-content">
                <h1 className="text-main-title">
                    João Araújo 
                    <span className='text-main-title__grey'> ✽ Staff Product Designer </span>
                    at Remote.com</h1>
                <p className="text-main-description">
                    I'm a Staff Product Designer with over 6 years of experience currently working on AI-powered experiences at Remote. 
                    <br/><br/>
                    I love to build software that people like to use. I've done so across health tech and HR tech. I'm also an enthusiast about how AI can help anyone build software – I've built <a href="https://globezones.com/" target="_blank">my own iOS app</a>.
                    <br/><br/>          
                    I'm originally from Portugal, spent half a decade in the UK, and I'm currently based in India.
                    </p>
            </div>
            <nav className="header-nav">
                <a
                    className="contact-link text-nav-link"
                    href={LINKEDIN_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    LinkedIn
                    <img
                        src={arrowOutwardIcon}
                        alt=""
                        className="contact-link-icon"
                    />
                </a>
                <div className="contact-github">
                    <a
                        className="contact-link text-nav-link"
                        href={GITHUB_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        GitHub
                        <img
                            src={arrowOutwardIcon}
                            alt=""
                            className="contact-link-icon"
                        />
                    </a>
                    <div className="contact-github-preview" aria-hidden="true">
                        <div className="contact-github-preview-panel">
                            <Contributions />
                        </div>
                    </div>
                </div>
                <a
                    className="contact-link text-nav-link"
                    href={X_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    X
                    <img
                        src={arrowOutwardIcon}
                        alt=""
                        className="contact-link-icon"
                    />
                </a>
                <a
                    className="contact-link text-nav-link"
                    href={CV_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    CV
                    <img
                        src={arrowOutwardIcon}
                        alt=""
                        className="contact-link-icon"
                    />
                </a>
                <button
                    type="button"
                    className="contact-link text-nav-link"
                    onClick={handleCopyEmail}
                >
                    {emailLabel}
                    <img
                        src={copyIcon}
                        alt=""
                        className="contact-link-icon"
                    />
                </button>
            </nav>
        </div>
    );
}
